import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  // The trigger Button is `type="text"`; let the theme handle hover/focus.
  // We only customize the resting icon color — antd's defaults work for size.
  button: {
    color: token.colorTextTertiary
  }
}))
